import React from "react";
import { useTheme } from "~/contexts/useTheme";
import styles from "~/widgets/ThemeToggle/ThemeToggle.module.scss";

/**
 * ThemeToggle button with moon/sun icon
 * Toggles between light and dark modes
 */
export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={styles.toggle}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
    >
      {theme === "light" ? "🌙" : "☀️"}
    </button>
  );
};

export default ThemeToggle;
